import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AdminExperiments from "@/pages/admin/AdminExperiments";

export const Route = createFileRoute("/admin/experiments")({
  head: () => pageHead("Admin \u2014 Experiments \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AdminExperiments,
});
